export type MarketsAssessmentMode = 'prod' | 'preview';

/**
 * Manual safety switch for conviction sliders and news assignment previews.
 * Keep this as `prod` in deployed builds. Change only this value to `preview`
 * when the assessment UI needs to be inspected without an attached assessment.
 */
export const MARKETS_ASSESSMENT_MODE = 'prod' as MarketsAssessmentMode;

export const isMarketsAssessmentPreviewEnabled = (
  mode: MarketsAssessmentMode = MARKETS_ASSESSMENT_MODE,
) => mode === 'preview';

export const MARKETS_ASSESSMENT_PREVIEW_ENABLED =
  isMarketsAssessmentPreviewEnabled();
  
